export default __webpack_public_path__ + "static/media/Header-15.3dcd7b0c.jpg";